$(function () {
    setTimeout(function(){
        $('input.quantity').eq(0).focus();
    }, 100);
});